import React from "react";
import BG1 from "../../Images/New/Activity/Online report-amico.svg";
import BG2 from "../../Images/New/Activity/Invoice-amico.svg";
import BG3 from "../../Images/New/Activity/Inventory.jpg";

const Activites1 = () => {
  return (
    <>
      <div className="flex justify-center mt-10">
        <div className="w-full max-w-7xl py-5">
          <div className="flex items-center">
            <hr className="w-[30%] h-1 bg-black hidden sm:block" />
            <div className="text-center w-full text-4xl sm:text-5xl font-bold">
              <p className="text-black">
                Empowering Your Business with <br />
                <span
                  className=""
                  style={{
                    backgroundImage:
                      "linear-gradient(120deg, #0077b3 0%, #00aacc 100%)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    color: "transparent",
                  }}
                >
                  Smart Accounting Solutions
                </span>{" "}
              </p>
            </div>
            <hr className="w-[30%] h-1 bg-black hidden sm:block" />
          </div>
          <div className="w-full flex flex-col sm:flex-row items-start bg-[#ffffff] rounded-lg p-2 mt-16 justify-between">
            <div className="bg-white flex justify-center items-center rounded-xl sm:w-[30%]">
              <img src={BG1} alt="Images" className="w-[100%]" />
            </div>
            <div className="sm:w-[70%] ml-4">
              <div>
                <p className="text-5xl font-bold mt-5">GST REPORTS</p>
                <p className="text-3xl  my-4 sm:my-7">
                  Generate comprehensive GST reports seamlessly with GST-enabled
                  accounting software for easy compliance and accurate
                  record-keeping
                </p>
              </div>
              <div className="list-none text-2xl mt-5 space-y-2">
                <li className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-caret-right-fill mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                  </svg>
                  Generate Excel Report for GSTR 1, GSTR 3B, ITC-04, CMP-08
                </li>
                <li className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-caret-right-fill mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                  </svg>
                  Annual Excel Reports for GSTR 9 & GSTR 4
                </li>
                <li className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-caret-right-fill mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                  </svg>
                  GST Register – comprehensive report
                </li>
                <li className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-caret-right-fill mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                  </svg>
                  EASYACC's GST - enabled accounting software
                </li>
              </div>
            </div>
          </div>
          <div className="w-full flex flex-col-reverse sm:flex-row items-start bg-[#ffffff] rounded-lg p-2 justify-between mt-5">
            <div className="sm:w-[70%] ml-4">
              <div>
                <p className="text-5xl font-bold mt-5">FINAL ACCOUNTS</p>
                <p className="text-3xl  my-4 sm:my-7">
                  Generate accurate and comprehensive Final Accounts seamlessly
                  within the accounting software for efficient financial
                  reporting
                </p>
              </div>
              <div className="list-none text-2xl mt-5 space-y-2">
                <li className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-caret-right-fill mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                  </svg>
                  Trial Balance
                </li>
                <li className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-caret-right-fill mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                  </svg>
                  Trading Account
                </li>
                <li className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-caret-right-fill mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                  </svg>
                  Profit & Loss Account
                </li>
                <li className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-caret-right-fill mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                  </svg>
                  Balance Sheet & Schedules
                </li>
                <li className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-caret-right-fill mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                  </svg>
                  Depreciation Statement
                </li>
              </div>
            </div>
            <div className="bg-white flex justify-center items-center rounded-xl sm:w-[30%]">
              <img src={BG2} alt="Images" className="w-[100%]" />
            </div>
          </div>
          <div className="w-full flex flex-col sm:flex-row items-center bg-[#ffffff] rounded-lg p-2 justify-between mt-5">
            <div className="bg-white flex justify-center items-center rounded-xl sm:w-[30%]">
              <img src={BG3} alt="Images" className="w-[100%]" />
            </div>
            <div className="sm:w-[70%] ml-4">
              <div>
                <p className="text-5xl font-bold mt-5">INVENTORY</p>
                <p className="text-3xl my-4 sm:my-7">
                  Simplify inventory management with tools for tracking and
                  controlling stock efficiently
                </p>
              </div>
              <div className="list-none text-2xl mt-5 space-y-2">
                <li className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-caret-right-fill mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                  </svg>
                  Goods Ledger & Summary with annexure
                </li>
                <li className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-caret-right-fill mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                  </svg>
                  Minimum-Maximum stock indication
                </li>
                <li className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-caret-right-fill mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                  </svg>
                  Stock Reports
                </li>
                <li className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-caret-right-fill mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                  </svg>
                  Negative Stock Indication
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Activites1;
